<template>
	<div id="group-with-loading" class="px-6 pb-2 pt-6">
		<form class="form-content p-1">
			<div class="vx-row w-full">
				<div class="vx-col w-full">
					<div class="vx-row mb-6">
						<div class="vx-col w-full">
							<label class="date-label"
								>{{ $t("Name") }}
								<i
									class="material-icons ml-1 text-center"
									style="font-size: 14px"
									:title="$t('Optimization.AcceptsNumbersLettersAndTheDashSign')"
								>
									info
								</i>
							</label>
							<vs-input
								v-model="group.name"
								class="mt-5 w-full"
								name="name"
								v-validate="'required|max:125'"
								@keypress="validateInputName"
							/>
							<span class="text-danger text-sm" v-show="errors.has('name')">{{
								errors.first("name") !== undefined ? $t(`VValidateMessage.${errors.first("name")}`) : ""
							}}</span>
						</div>
					</div>
					<div class="vx-row mb-6">
						<div class="vx-col w-full">
							<label class="date-label">{{ $t("Description") }}</label>
							<vs-textarea
								name="description"
								v-model="group.description"
								class="w-full"
								rows="6"
								v-validate="'max:250'"
							/>
							<span class="text-danger text-sm" v-show="errors.has('description')">{{
								errors.first("description") !== undefined
									? $t(`VValidateMessage.${errors.first("description")}`)
									: ""
							}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="vx-row p-1">
				<div class="vx-col w-full flex justify-end items-center">
					<vs-button color="danger" class="mr-3 mb-2" @click.prevent="closeSidebar()"
						>{{ $t("Cancel") }}
					</vs-button>
					<vs-button class="mr-3 mb-2" @click.prevent="submitForm()">{{
						isEditActive ? SubmitButtonTitleEdit : SubmitButtonTitleCreate
					}}</vs-button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import OptimizationGroup from "@/models/OptimizationGroup";
import moduleOptimizationGroup from "@/store/optimization-group/moduleOptimizationGroup.js";

export default {
	name: "OptimizationGroupForm",
	props: {
		isEditActive: {
			type: Boolean,
			required: false,
		},
		groupProps: {
			type: Object,
		},
	},
	data() {
		return {
			group: new OptimizationGroup({}),
		};
	},
	computed: {
		SubmitButtonTitleCreate() {
			return this.$t("Save");
		},
		SubmitButtonTitleEdit() {
			return this.$t("Crud.Update");
		},
	},
	mounted() {
		if (this.isEditActive) {
			this.findGroupById(this.groupProps.id);
		}
	},
	created() {
		if (!moduleOptimizationGroup.isRegistered) {
			this.$store.registerModule("moduleOptimizationGroup", moduleOptimizationGroup);
			moduleOptimizationGroup.isRegistered = true;
		}
	},
	methods: {
		submitForm() {
			this.$vs.loading();
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (this.isEditActive) {
						this.update();
					} else {
						this.save();
					}
				} else {
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorFields.Title"),
						text: this.$t("ErrorFields.Text"),
					});
					this.$vs.loading.close();
				}
			});
		},
		save() {
			let params = {
				name: this.group.name,
				description: this.group.description,
			};
			this.$store
				.dispatch("moduleOptimizationGroup/save", params)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Group.Messages.TitleConfirmCreate"),
						text: this.$t("Group.Messages.TextConfirmCreate"),
					});
					this.$vs.loading.close();
					this.$emit("showSidebar", false);
					this.$emit("refreshList");
					this.group = new OptimizationGroup({});
					this.$validator.reset();
					return res;
				})
				.catch((err) => {
					this.$vs.loading.close();
					console.error(err);
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
				});
		},
		update() {
			let params = {
				name: this.group.name,
				description: this.group.description ? this.group.description : "",
			};
			this.$store
				.dispatch("moduleOptimizationGroup/update", {id: this.groupProps.id, items: params})
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Group.Messages.TitleConfirmUpdate"),
						text: this.$t("Group.Messages.TextConfirmUpdate"),
					});
					this.$vs.loading.close();
					this.$emit("showSidebarEdit", false);
					this.$emit("refreshList");
					this.$validator.reset();
					return res;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		findGroupById(id) {
			this.$vs.loading({
				container: "#group-with-loading",
				scale: 1,
				type: "sound",
			});
			this.$store
				.dispatch("moduleOptimizationGroup/findById", id)
				.then((res) => {
					this.group = res.data[0];
					this.$vs.loading.close("#group-with-loading > .con-vs-loading");
				})
				.catch((err) => {
					console.error(err);
				});
		},
		closeSidebar() {
			if (this.isEditActive) {
				this.$emit("showSidebarEdit", false);
			} else {
				this.$emit("showSidebar", false);
			}
		},
		validateInputName(event) {
			let regex = /^[a-zA-Z0-9_-]+$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
	},
};
</script>
